import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  const headingRef = useRef<HTMLHeadingElement>(null);
  const subRef = useRef<HTMLParagraphElement>(null);
  const ctaRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const items = [headingRef.current, subRef.current, ctaRef.current];
    items.forEach((el, i) => {
      if (!el) return;
      el.style.opacity = '0';
      el.style.transform = 'translateY(28px)';
      setTimeout(() => {
        if (!el) return;
        el.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
        el.style.opacity = '1';
        el.style.transform = 'translateY(0)';
      }, 200 + i * 160);
    });
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/687bb5f5715011c901a07ace407a554b.jpg"
          alt="Holston Development Group"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#001F4E]/55 via-[#001F4E]/50 to-[#001F4E]/65" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 text-center">
        <div className="max-w-4xl mx-auto">
          <p
            className="text-[#00A3E0] text-sm font-semibold uppercase tracking-widest mb-6"
            style={{ opacity: 0 }}
            ref={subRef as React.RefObject<HTMLParagraphElement>}
          >
            Holston Development Group
          </p>
          <h1
            ref={headingRef}
            className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold text-white leading-tight mb-6"
          >
            Moving Your Vision Forward
            <br />
            <span className="text-[#00A3E0]">Through Strategic Execution</span>
          </h1>
          <p
            className="text-white/80 text-lg lg:text-xl max-w-2xl mx-auto leading-relaxed mb-10"
            style={{ opacity: 0 }}
          >
            A multi-discipline development group with over 60 years of combined experience,
            delivering innovative solutions across industries nationwide.
          </p>
          <div ref={ctaRef} className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="px-8 py-3.5 rounded-md bg-[#0050B2] text-white font-semibold text-sm hover:bg-[#00A3E0] transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              Get In Touch
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 rounded-md border border-white/40 text-white font-semibold text-sm hover:bg-white/10 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              Learn More
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/50 animate-bounce">
        <i className="ri-arrow-down-line text-xl" />
      </div>
    </section>
  );
}
